import React from "react";
import { Box, ButtonGroup } from "@mui/material";

import {
  MarkButton,
  LinkButton,
  RemoveLinkButton,
  SizeButton,
  ColorButton,
  AlignButton,
  MacroButton,
} from "../components";
import { classes } from "../styles";

interface IToolbarProps {
  error?: boolean;
  disabled?: boolean;
  disableMacros: boolean;
  macroType: "Terms" | "Orientation" | "Email";
}

export const Toolbar: React.FC<IToolbarProps> = ({
  macroType,
  disableMacros,
  error = false,
  disabled = false,
}) => {
  return (
    <Box sx={error ? classes.toolbarError : classes.toolbar}>
      <ButtonGroup
        disableElevation
        size="small"
        color="primary"
        variant="contained"
      >
        <MarkButton disabled={disabled} format="bold" icon="format_bold" />
        <MarkButton disabled={disabled} format="italic" icon="format_italic" />
        <MarkButton
          disabled={disabled}
          format="underline"
          icon="format_underline"
        />
      </ButtonGroup>
      <Box sx={classes.divider} />
      <ButtonGroup
        disableElevation
        size="small"
        color="primary"
        variant="contained"
      >
        <SizeButton disabled={disabled} />
      </ButtonGroup>
      <Box sx={classes.divider} />
      <ButtonGroup
        disableElevation
        size="small"
        color="primary"
        variant="contained"
      >
        <LinkButton disabled={disabled} />
        <RemoveLinkButton disabled={disabled} />
      </ButtonGroup>
      <Box sx={classes.divider} />
      <ButtonGroup
        disableElevation
        size="small"
        color="primary"
        variant="contained"
      >
        <ColorButton
          disabled={disabled}
          format="color"
          icon="format_color_text"
        />
        <ColorButton
          disabled={disabled}
          format="background"
          icon="format_color_fill"
        />
      </ButtonGroup>
      <Box sx={classes.divider} />
      <ButtonGroup
        disableElevation
        size="small"
        color="primary"
        variant="contained"
      >
        <AlignButton
          disabled={disabled}
          format="left"
          icon="format_align_left"
        />
        <AlignButton
          disabled={disabled}
          format="center"
          icon="format_align_center"
        />
        <AlignButton
          disabled={disabled}
          format="right"
          icon="format_align_right"
        />
      </ButtonGroup>
      {!disableMacros && (
        <>
          <Box sx={classes.divider} />
          <ButtonGroup
            disableElevation
            size="small"
            color="primary"
            variant="contained"
          >
            <MacroButton disabled={disabled} macroType={macroType} />
          </ButtonGroup>
        </>
      )}
    </Box>
  );
};
